import hooks from './signup.hooks';
import createSchema from './signup.schema';

export default (app) => {
  const service = app.service('api/signup');
  service.schema = createSchema(app);
  service.hooks(hooks);
};
